import styled from 'styled-components';
import { Box } from '@interstate/components/Box';

export const OptionsButton = styled(Box)`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: transparent;
    gap: 0.25rem;
    border: none;
    outline: none;
    color: #005ba8;
    & > * {
        pointer-events: none;
    }
    div {
        color: inherit;
    }
    &.disabled-button {
        cursor: not-allowed;
        color: #a0a0a0;
    }
    &:focus {
        outline: 2px solid #005ba8;
        outline-offset: 2px;
    }
`;
